import { ButtonGroup, FormControl, Grid, Typography } from "@material-ui/core";
import RegularButton from "components/CustomButtons/Button";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { blue, red } from "@material-ui/core/colors";
import { selectInput } from "redux/actions/formGenerator/formGeneratorActions";
import { delInput } from "redux/actions/formGenerator/formGeneratorActions";
import { animations } from "helpers/animations";

export const FormPreview = () => {
  const { inputs } = useSelector(
    ({ formGeneratorReducer }) => formGeneratorReducer
  );
  const dispatch = useDispatch();

  const handleSelectInput = (e, id) => {
    dispatch(selectInput(id));
  };
  const handleRemoveInput = (e, id) => {
    dispatch(delInput(id));
  };
  return (
    <FormControl
      fullWidth
      style={{
        borderRadius: 16,
        padding: 16,
        minHeight: 200,
        maxHeight: 600,
        overflow: "hidden",
        overflowY: "scroll",
      }}
    >
      <Typography align="center" variant="h5">
        Form Preview
      </Typography>
      <Grid container spacing={1}>
        {inputs.map((value) => (
          <Grid
            className={animations.fadeIn}
            item
            xs={12}
            sm={value.input.cols}
            style={{
              position: "relative",
              // boxShadow: value.isSelected && `0px 10px 15px -3px ${blue[50]}`
              border: value.isSelected && `1px solid ${blue[200]}`,
              borderRadius: 8,
              transition: ".3s ease",
            }}
          >
            {value.input.component}
            <ButtonGroup
              variaint="outlined"
              size="small"
              style={{
                position: "absolute",
                right: 8,
                top: "50%",
                transform: `translateY(${
                  value.input.type === "text" ? "-50%" : "-100%"
                })`,
              }}
            >
              <RegularButton
                justIcon
                round
                color="transparent"
                tooltip=""
                size="sm"
                onClick={(e) => handleSelectInput(e, value.id)}
              >
                <EditIcon style={{ color: blue[300] }} />
              </RegularButton>
              <RegularButton
                justIcon
                round
                color="transparent"
                tooltip=""
                size="sm"
                onClick={(e) => handleRemoveInput(e, value.id)}
              >
                <DeleteIcon style={{ color: red[300] }} />
              </RegularButton>
            </ButtonGroup>
          </Grid>
        ))}
        {inputs.length > 0 && (
          <Grid item xs={12}>
            <RegularButton
              size="sm"
              color="info"
              tooltip="Aceptar"
              onClick={() => alert("Funciona :D ")}
              fullWidth
            >
              Ejemplo
            </RegularButton>
          </Grid>
        )}
      </Grid>
    </FormControl>
  );
};
